"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwaCheckoutButtonWidget = bwaCheckoutButtonWidget;
exports.checkoutAddressFillSelectionWidget = checkoutAddressFillSelectionWidget;
var _utils = require("../../../utils/utils");
var _constants = require("../../../constants/constants");
function getCheckoutButtonType(type) {
  if (!type) return null;
  var normalizedType = type.toLowerCase().replace(/-/g, '_');
  return Object.values(_constants.CHECKOUT_BUTTON_TYPE).find(function (value) {
    return value.toLowerCase() === normalizedType;
  });
}
function generateBwACheckoutButtonUrl(type) {
  var params = {
    loggedIn: false
  };
  var buttonType = getCheckoutButtonType(type);
  if (buttonType === _constants.CHECKOUT_BUTTON_TYPE.WITH_ADDRESS_PREFILL) {
    params.variant = 'import_address';
  } else if (buttonType === _constants.CHECKOUT_BUTTON_TYPE.WITHOUT_ADDRESS_PREFILL) {
    params.mode = 'without_address_prefill';
  }
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.CHECKOUT_BUTTON, params);
}
function bwaCheckoutButtonWidget(id, cssClass, type) {
  return (0, _utils.generateIframe)(id, cssClass, generateBwACheckoutButtonUrl(type));
}
function checkoutAddressFillSelectionWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, generateCheckoutAddressFillSelectionWidgetUrl());
}
function generateCheckoutAddressFillSelectionWidgetUrl() {
  var params = {
    variant: 'OPTIONAL_ADDRESS_SELECTION'
  };
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.CHECKOUT_BUTTON, params);
}
//# sourceMappingURL=bwa-checkout-button.js.map
